"use client"

import { useState, useEffect } from 'react';

const useScrollTrigger = (triggerPoint: number) => {
    const [isTriggered, setIsTriggered] = useState<boolean>(false);

    const handleScroll = () => {
        const scrollPosition = window.scrollY;
        if (scrollPosition >= triggerPoint) {
            setIsTriggered(true);
        } else {
            setIsTriggered(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [triggerPoint]);

    return isTriggered;
};

export default useScrollTrigger;